import React from 'react';
import {
  FaShoppingCart,
  FaArrowUp,
  FaArrowDown,
  FaFileInvoiceDollar,
  FaHandHoldingUsd,
  FaChartLine,
} from 'react-icons/fa';

const iconMap = {
  ventas: FaFileInvoiceDollar,
  compras: FaShoppingCart,
  cobrado: FaHandHoldingUsd,
  ganancias: FaChartLine,
};

const TarjetaMetrica = ({ titulo, monto, porcentajeCambio, tendencia, icono, formatoMoneda }) => {
  const Icono = iconMap[icono] || FaChartLine;
  const esPositivo = tendencia === 'subida';

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex flex-col gap-3 hover:shadow-md transition-shadow duration-200">
      {/* Header con icono y título */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-color-primario bg-opacity-10 rounded-lg flex items-center justify-center">
          <Icono className="text-color-primario text-lg" />
        </div>
        <span className="text-sm text-gray-500 font-medium">{titulo}</span>
      </div>

      {/* Monto */}
      <p className="text-2xl font-bold text-gray-800">
        {formatoMoneda ? formatoMoneda(monto) : `$${monto.toLocaleString()}`}
      </p>

      {/* Porcentaje de cambio */}
      <div className="flex items-center gap-1.5">
        {esPositivo ? (
          <FaArrowUp className="text-color-secundario text-xs" />
        ) : (
          <FaArrowDown className="text-gray-400 text-xs" />
        )}
        <span
          className={`text-sm font-medium ${
            esPositivo ? 'text-color-secundario' : 'text-gray-500'
          }`}
        >
          {Math.abs(porcentajeCambio)}%
        </span>
        <span className="text-xs text-gray-400 ml-1">vs 7 días anteriores</span>
      </div>
    </div>
  );
};

export default TarjetaMetrica;
